export const createPasswordFormDefaultValues = {
    password: '',
    password_again: '',
};
